// import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
import {getApiProps} from "@/lib/lib";

export default {
    state: {
        units_msgs_GroupBy: [],
        units_msgs_GroupBy_index: [],
    },
    actions: {
        fetchUnitsMsgsGroupBy4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let sensors = Object.keys(getters.getUnitsLmsgsByIds[args.unitId]?.sensors || {})
                let isLmsgsFullLoad = getters.getUnitsIdsIsLmsgFullLoad.find(id => id == args.unitId)
                if (!isLmsgsFullLoad || !sensors?.includes(args.groupBy)) {
                    console.warn("No sensors: Unit:" + args.unitId + ' Sensor GroupBy:' + args.groupBy)
                    resolve(true)
                }

                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupBy4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastUnitsMsgsGroupBy', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupByChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('units_msgs_groupby', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;delete params.groupBy;
                this.$api.unitsmsgs_groupby.getGroupBy4Date(args.unitId, args.date, args.groupBy, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeUnitsMsgsGroupBy', response.data)
                            commit('setUnitsMsgsGroupByIndex', {...args, count: response.data.length})
                            if (!args.unitId && response.data.length) {
                                // debugger
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupBy4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastUnitsMsgsGroupBy', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupByChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchUnitsMsgsGroupBy4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }

                let unitsMsg = getters.getUnitsMsgsGroupBy.find(t => (t.unit_id == args.unitId && t.time_start?.utc == args.from && t.time_end?.utc == args.to))
                if (unitsMsg) {
                    return resolve(true)
                }

                dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupBy4Period', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastUnitsMsgsGroupBy', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupByChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('units_msgs_groupby', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;delete params.groupBy;
                this.$api.unitsmsgs_groupby.get4Period(args.unitId, args.from, args.to, args.groupBy, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeUnitsMsgsGroupBy', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupBy4Period', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastUnitsMsgsGroupBy', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchUnitsMsgsGroupByChanged', args, inprogress: false})
                        }
                    });
            })
        },

        //sayHello() {}
    },
    mutations: {
        setUnitsMsgsGroupByIndex(state, params) {
            let i = state.units_msgs_GroupBy_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.units_msgs_GroupBy_index.push(Object.freeze({...params}))
            } else {
                state.units_msgs_GroupBy_index[i] = Object.freeze({...state.units_msgs_GroupBy_index[i], ...params})
            }
        },
        storeUnitsMsgsGroupBy(state, nUnitsMsgs) {
            nUnitsMsgs = nUnitsMsgs
                .filter(t => !state.units_msgs_GroupBy.find(st => {
                    return st.unit_id == t.unit_id
                        && st.type == t.type
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
                .map(t => Object.freeze(t))

            // if(nUnitsMsgs.length) state.units_msgs_GroupBy.push(...nUnitsMsgs)
            if (!nUnitsMsgs.length) return false
            if (!state.units_msgs_GroupBy.length) {
                state.units_msgs_GroupBy = nUnitsMsgs
                return true
            }

            nUnitsMsgs.forEach(nG => {
                let index = state.units_msgs_GroupBy.findIndex(g => g.xid == nG.xid)
                if (index !== -1) {
                    state.units_msgs_GroupBy[index] = nG
                } else {
                    state.units_msgs_GroupBy.push(nG)
                }
            })
        },
        clearUnitsMsgsGroupBy(state, {unitId} = {}) {
            if (unitId) {
                state.units_msgs_GroupBy = state.units_msgs_GroupBy.filter(g => (g.unit_id || g.object_id) != unitId)
                state.units_msgs_GroupBy_index = state.units_msgs_GroupBy_index.filter(i => i.unitId != unitId)
            } else {
                state.units_msgs_GroupBy = [];
                state.units_msgs_GroupBy_index = [];
            }
        },
    },
    getters: {
        getUnitsMsgsGroupByIndex(state) {
            return state.units_msgs_GroupBy_index
        },
        getUnitsMsgsGroupBy(state) {
            return state.units_msgs_GroupBy
        },
    }
}
